import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// "OFFLINE — NO SIGNAL" in the corner while the device has no connection.
// (Saving offline is done per screen through the upload queue —
// services/fieldOffline.js and the OfflineQueueBanner.)
export default function OfflineStatusPill() {
  const { t } = useTranslation();
  const [isOnline, setIsOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);

  useEffect(() => {
    const up = () => setIsOnline(true);
    const down = () => setIsOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  if (isOnline) return null;
  return (
    <div
      role="status"
      data-testid="offline-pill"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px 16px",
        borderRadius: "8px",
        backgroundColor: "rgba(255,68,102,0.1)",
        border: "1px solid rgba(255,68,102,0.3)",
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
      }}
    >
      <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#ff4466", animation: "pulse 1.5s infinite" }} />
      <span style={{ color: "#ff4466", fontSize: "11px", fontWeight: "700", letterSpacing: "2px" }}>{t("offline.statusOffline")}</span>
    </div>
  );
}
